import CampAthletesIndex from './CampAthletesIndex';
import CampAthletesCreate from './CampAthletesCreate';
import CampAthletesSettings from './CampAthletesSettings';
import CampAthletesSingle from './CampAthletesSingle';

export default function (app) {

    const settings = CampAthletesSettings;

    app.addModel({
        name: settings.key,
        path: settings.path,
        modelName: settings.modelName,
        endpoint: settings.endpoint,
        idKey: settings.idKey,
        primaryKey: settings.primaryKey,
    });

    // app.addMenu({
    //     key: settings.key,
    //     zone: settings.zone,
    //     label: settings.title,
    //     priority: 14,
    //     items: [
    //         {
    //             label: "All",
    //             path: settings.path,
    //             caps: settings.indexCaps
    //         },
    //         {
    //             label: "Add New",
    //             path: settings.path + "/create",
    //             caps: settings.createCaps
    //         }
    //     ],
    // });

    CampAthletesIndex(app, settings);

    CampAthletesCreate(app, settings);

    CampAthletesSingle(app, settings);

}